import { PercentPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable()
@Pipe({ name: 'percentageChangeFrom' })
export class PercentageChangeFromPipe implements PipeTransform {

  public constructor(private readonly percentPipe: PercentPipe) {}

  public transform(value: number, valueFrom?: number, digitsInfo = '1.0-1', negativeIsGood = false, neutral = false): string {
    if (!value || !valueFrom) { return ''; }
    const change = (value / valueFrom) - 1;
    const positiveClass = neutral ? '' : negativeIsGood ? 'bad ' : 'good ';
    const negativeClass = neutral ? '' : negativeIsGood ? 'good ' : 'bad ';
    return `<em class="${change > 0 ? positiveClass : change < 0 ? negativeClass : ''}percentage-change">${change > 0 ? '<i class="fa-solid fa-caret-up"></i> +' : '<i class="fa-solid fa-caret-down"></i> '}${this.percentPipe.transform(change, digitsInfo)}</em>`;
  }

}
